module.exports = __webpack_public_path__ + "static/logo_hydroszpak-de300bd19e1d2190acb1783d846680d8.svg";